import React from 'react';
import '../assests/css/font-size-family.css';
import Header from '../Components/Headers/Header';
import '../assests/css/PrivacyPolicy.css';
import Footer from '../Components/Footers/Footer';

const RefundPolicy = () => {
    return (
        <div className='privacypolicy policiez'>
            <section className='bg-privacy-policy-top mb-3'>
                <Header />
                <div className='container '>
                    <div className='row'>
                        <div className='col-lg-12 my-4 text-center'>
                            <p className='text-white f-72 my-5 f-pop-med'>Refund Policy</p>
                        </div>
                    </div>
                </div>
            </section>
            <section className='policies pt-5 pb-5'>
                <div className='container  p-cus-policy'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <p className='f-25 f-pop-med'>Our Refund Policy </p>
                            <p className='f-14 mt-4 mb-4 f-pop-reg'>
                                In the event that a customer wants a refund from Metro 24 x 7, the reimbursement will be made to the card used to make the payment. From the time the company gets the refund request, it can take up to 48 hours to reimburse the amount.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default RefundPolicy;